/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentPolicyGrantIDForm,
  AgentPolicyGrantIDForm$Outbound,
  AgentPolicyGrantIDForm$outboundSchema,
} from "../components/agentpolicygrantidform.js";

export type DeleteAgentPolicyGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAgentPolicyGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentPolicyGrantIDForm: AgentPolicyGrantIDForm;
};

/** @internal */
export type DeleteAgentPolicyGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAgentPolicyGrantSecurity$outboundSchema: z.ZodMiniType<
  DeleteAgentPolicyGrantSecurity$Outbound,
  DeleteAgentPolicyGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAgentPolicyGrantSecurityToJSON(
  deleteAgentPolicyGrantSecurity: DeleteAgentPolicyGrantSecurity,
): string {
  return JSON.stringify(
    DeleteAgentPolicyGrantSecurity$outboundSchema.parse(
      deleteAgentPolicyGrantSecurity,
    ),
  );
}

/** @internal */
export type DeleteAgentPolicyGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentPolicyGrantIDForm: AgentPolicyGrantIDForm$Outbound;
};

/** @internal */
export const DeleteAgentPolicyGrantRequest$outboundSchema: z.ZodMiniType<
  DeleteAgentPolicyGrantRequest$Outbound,
  DeleteAgentPolicyGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentPolicyGrantIDForm: AgentPolicyGrantIDForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentPolicyGrantIDForm: "AgentPolicyGrantIDForm",
    });
  }),
);

export function deleteAgentPolicyGrantRequestToJSON(
  deleteAgentPolicyGrantRequest: DeleteAgentPolicyGrantRequest,
): string {
  return JSON.stringify(
    DeleteAgentPolicyGrantRequest$outboundSchema.parse(
      deleteAgentPolicyGrantRequest,
    ),
  );
}
